import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { of } from "rxjs";
import { tap, concatMap, switchMap, map, take, filter } from "rxjs/operators";
import { FavOpsService } from "src/app/card-operations/services/favoriteOperations.service";
import { BalanceService } from "../services/cardBalance.service";
import { FavoriteService } from "../services/favorite.service";
import { HomeActions } from "./home-action-types";
import { CardBalanceAdded, CardsLoaded, FavoriteItemAdded, FavoritesLoaded } from "./home-actions";

@Injectable()
export class HomeEffects{

    constructor(
        private actions$:Actions,
        private favoritesService:FavoriteService,
        public restFavOps: FavOpsService,
        private toastr: ToastrService,
        private translate: TranslateService,
        public restBalance: BalanceService
    ){}

    private favorite!:string;
    private description!:string;
    private type!:string;
    private typeDescription!:string;

    loadHome$ = createEffect(
        () => this.actions$.pipe(
            ofType(HomeActions.loadUserFavorites),
            concatMap(() => this.favoritesService.getFavoritesResult()),
            filter(serviceResult => 
                (serviceResult.userFavorites.length > 0) || (serviceResult.virtualCards.length > 0)
            ),
            switchMap(x => of(
                FavoritesLoaded({favorites: x.userFavorites}),
                CardsLoaded({cards: x.virtualCards})
            )),
            //take(1)
        )
    )

    deleteFavItem$ = createEffect(
        () => this.actions$.pipe(
            ofType(HomeActions.deleteFavoriteItem),
            concatMap((item) => this.restFavOps.deleteFavoriteResult(item.favId)),
            tap((resp:any) => {
                if (resp.result.code == 33) {
                    this.toastr.info(
                        this.translate.instant('HOME_LOGIN_ERROR')
                    );
                } else if (resp.result.code == 0) {
                    this.toastr.info(
                        this.translate.instant('HOME_DELETE_FAV_SUCCESSFUL')
                    );
                } else {
                    this.toastr.info(
                        this.translate.instant('HOME_DELETE_FAV_FAILED') + resp!=null?""+resp.result.message:""
                    );
                }
            }),
        ),
        {dispatch: false}
    )

    addFavItem$ = createEffect(
        () => this.actions$.pipe(
            ofType(HomeActions.upsertFavoriteItem),
            tap(item => {
                this.favorite = item.favorite;
                this.description = item.description;
                this.type = item.favoriteType;
                this.typeDescription = item.typeDescription;
            }),
            concatMap(
                (item) => this.restFavOps.addFavoriteResult(item.favorite, item.description, item.favoriteType)
            ),
            tap((resp:any) => {
                if (resp.result.code == 33) {
                    this.toastr.info(
                        this.translate.instant('HOME_LOGIN_ERROR')
                    );
                } else if (resp.result.code == 0) {
                    this.toastr.info(
                        this.translate.instant('HOME_ADD_FAV_SUCCESSFUL')
                    );
                } else {
                    this.toastr.info(
                        this.translate.instant('HOME_ADD_FAV_FAILED') + resp!=null?""+resp.result.message:""
                    );
                }
            }),
            map(item => FavoriteItemAdded({
                favoriteItem: {
                    type: Number(this.type),
                    favorite: this.favorite,
                    description: this.description,
                    typeDescription: this.typeDescription,
                    favId: item.favId
                }
            }))
        ),
    );

    addCardBalance$ = createEffect(
        () => this.actions$.pipe(
            ofType(HomeActions.upsertCardBalance),
            concatMap(
                (item) => this.restBalance.getCardBalanceResult(item.alias).pipe(
                    map(response => response.cardlist[0])
                )
            ),
            map(item => CardBalanceAdded({balance: item}))
        ),
    );

}